<template>
  <v-container fluid class="pa-0 ma-8 mt-2">
    <v-autocomplete
      v-model="accountant_id"
      label="المحاسب"
      :items="filteredAccountants"
      item-title="fullname"
      item-text=""
      item-value="id"
      placeholder="Search by accountant"
      prepend-inner-icon="mdi-magnify"
      menu-icon=""
      rounded
      theme="light"
      variant="solo"
      auto-select-first
      item-props
      class="mx-auto"
      width="50%"
    ></v-autocomplete>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="accTransactions"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>حركات الصناديق </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogTransactionWithdraw
            v-if="accountant_id != -1"
            :item="item"
            :saveFunction="saveWithdraw"
            iconName="mdi-coin"
          />
          <!-- <v-btn v-if="accountant_id != -1" @click="getMoney">تحصيل</v-btn> -->
        </v-toolbar>
      </template>
      <template v-slot:[`item.transactionType`]="{ item }">
        <v-container>
          <p class="text-red" v-if="item.transactionType == 'withdraw'">
            {{ $t(`${item.transactionType}`) }}
          </p>
          <p class="text-green" v-if="item.transactionType == 'feed'">
            {{ $t(`${item.transactionType}`) }}
          </p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogTransactionWithdraw from "@/components/dialogs/DialogTransactionWithdraw.vue";
// import DialogSimp from "@/components/DialogSimp.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogTransactionWithdraw,
    OverlayLoader,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "النوع", key: "transactionType" },
      { title: "القيمة", key: "value" },
      { title: "الرصيد السابق", key: "old_balance" },
      { title: "الرصيد الحالي", key: "current_balance" },
      // { title: "آخر قراءة", key: "last_reading" },
      // { title: "القراءة السابقة", key: "last_paid" },
      { title: "تاريخ العملية", key: "created_at" },
      // { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
    accountant_id: -1,
  }),
  computed: {
    transactions() {
      return repo.transactions.getAllTransactions();
    },
    accTransactions() {
      if (this.accountant_id == -1) {
        return [];
      }
      let uu = this.transactions.filter(
        (x) => x.accountant_id == this.accountant_id
      );
      console.log("uu", uu);
      return uu;
    },
    accountants() {
      return repo.users.getAllUsers();
    },
    filteredAccountants() {
      console.log("users", this.accountants);
      const fa = this.accountants.filter((u) => {
        if (u.roles.some((obj) => obj.rolename === "accountant")) {
          return true;
        }
      });
      console.log("fa", fa);
      return fa;
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await repo.transactions.fetchAll();
      const res2 = await repo.users.fetchAll();
      if (res && res2) {
        //swalFun.success("success");
        console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async saveWithdraw(formData) {
      console.log("form before", formData);
      formData.accountant_id = this.accountant_id;
      console.log("form after", formData);
      const res = await repo.transactions.addWithdraw(formData);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
